import React, { useEffect, useState } from 'react';
import { get, isNull, isEmpty } from 'lodash';
import { Redirect, Link, useLocation } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import {
  authenticateUser,
  logoutUser,
  setloginData,
  setApplicationNumber,
  authenticateUserUsingToken,
} from '../../../actions/loginActions';
import CustomButton from '../../../components/CustomButton';
import CustomTextField from '../../../components/CustomTextField';

// Images
import ApplicationIcon from '../../../assets/application.svg';
import PasswordIcon from '../../../assets/password.svg';

const Login = () => {
  const defaultInputs = {
    password: {
      type: 'password',
      value: '',
    },
    uid: {
      type: 'generic',
      value: '',
      errorLabel: '',
      error: false,
    },
  };

  // States
  const [deviceId, setDeviceId] = useState('214353455213');
  const [loginType] = useState('student');
  const [inputs, setInputs] = useState(defaultInputs);
  const [isDisabled, setDisabled] = useState(true);
  const [redirectToOtp, setRedirectToOtp] = useState(false);
  const [redirectToHome, setRedirectToHome] = useState(false);
  const [recaptchaKey, setRecaptchaKey] = useState('');

  // Redux Props
  const dispatch = useDispatch();
  const loginData = useSelector((state) => get(state, 'loginReducer.data', {}));
  const isLoginLoading = useSelector((state) =>
    get(state, 'loadingReducer.isLoginLoading', false)
  );
  const appNumber = useSelector((state) =>
    get(state, 'loginReducer.applicationNumber', '')
  );

  // Functions
  const onLogin = () => {
    let isUId =
      loginType === 'student' ? validateForm('uid', inputs.uid.value) : true;
    let isUID2 =
      loginType === 'student' ? validateForm('uid', appNumber.uid) : true;

    if (!deviceId) {
      setDeviceId(Math.floor(100000000 + Math.random() * 900000000));
    }
    let isUIdValid = validateForm('uid', inputs.uid.value);
    let isUIdValid2 = validateForm('uid', appNumber.uid);

    if ((isUId || isUID2) && (isUIdValid || isUIdValid2)) {
      dispatch(
        setloginData({
          uid: inputs.uid.value ? inputs.uid.value : appNumber.uid,
          pass: inputs.password.value,
          loginType: loginType,
          deviceId: deviceId,
        })
      );

      authenticateUser(
        inputs.uid.value ? inputs.uid.value : appNumber.uid,
        inputs.password.value,
        loginType,
        deviceId,
        recaptchaKey,
        null,
        dispatch
      ).then((data) => {
        if (!isNull(get(data, 'data.OTP', null))) {
          setRedirectToOtp(true);
        }
      });
    }
  };

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key
    let code = e.keyCode || e.which;
    if (code === 13) {
      onLogin();
    }
  };

  useEffect(() => {
    if (!deviceId) {
      setDeviceId(Math.floor(100000000 + Math.random() * 900000000));
    }

    if (get(loginData, 'jwt', false)) {
      setRedirectToHome(true);
    }
  }, [loginData]);

  useEffect(() => {
    handleDisable();
  }, [inputs.password.value, inputs.uid.value, appNumber.uid, recaptchaKey]);

  const location = useLocation();

  useEffect(() => {
    if (!deviceId) {
      setDeviceId(Math.floor(100000000 + Math.random() * 900000000));
    }
    if (get(loginData, 'jwt', false)) {
      logoutUser(get(loginData, 'jwt', false), dispatch);
    }
    // Login via token from external links
    if (
      location &&
      location.state &&
      location.state.from &&
      location.state.from.search !== ''
    ) {
      let parsedT = parseToken(location.state.from.search);
      loginUsingJwtToken(parsedT);
    }
  }, []);

  const parseToken = (str) => {
    if (str) {
      return str.split('?jwt=')[1];
    }
    return str;
  };

  const loginUsingJwtToken = (token) => {
    if (token != '') {
      authenticateUserUsingToken(token, deviceId, dispatch);
    }
  };

  // const handleChange = event => {
  //   setLoginType(event.target.value);
  // };

  const handleDisable = () => {
    //const validateForm = (id, val) => {
    let isUId = validateForm('uid', inputs.uid.value);
    let isUID2 = validateForm('uid', appNumber.uid);
    if ((isUId || isUID2) && inputs.password.value && !isEmpty(recaptchaKey)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const onChangeTextInput = (id, value) => {
    setInputs({ ...inputs, [id]: { type: inputs[id].type, value: value } });
    if (id == 'uid') {
      dispatch(
        setApplicationNumber({
          uid: value,
        })
      );
    }
  };
  const validateForm = (id, val) => {
    if (!val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else if (
      !/^\d{8}$/.test(inputs.uid.value ? inputs.uid.value : appNumber.uid)
    ) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: 'Please enter valid Application Form Number',
          error: true,
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
          error: false,
        },
      }));
      return true;
    }
  };

  if (redirectToOtp) {
    return <Redirect to="login/verify-otp" />;
  }

  if (redirectToHome) {
    return <Redirect to="/" />;
  }

  return (
    <div className="form-wrapper">
      <div className="greeting">
        <h1 className="welcome">Welcome!</h1>
        <p className="info">Login to your account</p>
      </div>
      <div className="input-container">
        <CustomTextField
          id="uid"
          label="Application Form Number"
          color="secondary"
          fullWidth
          onChange={(e) => onChangeTextInput('uid', e.target.value)}
          icon={ApplicationIcon}
          error={inputs.uid.error}
          helperText={inputs.uid.errorLabel}
          onKeyPress={handleKeypress}
          defaultValue={appNumber.uid}
        />
      </div>
      <div className="input-container">
        <CustomTextField
          id="password"
          label="Password"
          type="password"
          color="secondary"
          fullWidth
          onChange={(e) => onChangeTextInput('password', e.target.value)}
          icon={PasswordIcon}
          onKeyPress={handleKeypress}
        />
        <p className="flex flex-right mt-10">
          <Link
            to={{
              pathname: '/login/forgot-password',
            }}
            className="secondary-link"
          >
            Forgot Password?
          </Link>
        </p>
      </div>
      <div className="mb-10 ">
        <ReCAPTCHA
          sitekey="6LfFAOUUAAAAAPw809L_-Vrqr0_Wxc9alVQeYw_8"
          onExpired={() => setRecaptchaKey('')}
          onErrored={() => setRecaptchaKey('')}
          onChange={(value) => setRecaptchaKey(value)}
        />
      </div>

      <div className="mb-10">
        <CustomButton
          name="Sign In"
          handler={onLogin}
          disabled={isDisabled || isLoginLoading}
          progressShow={isLoginLoading}
          className={isLoginLoading ? 'loading-btn' : ''}
        />
      </div>
      <div className="seprator">
        <span>or</span>
      </div>

      <p className="flex flex-center">
        New user? &nbsp;{' '}
        <Link
          to={{
            pathname: '/login/generate-password',
          }}
          className="secondary-link"
        >
          Generate Password
        </Link>
      </p>
      <p className="flex flex-center version-code">Version 0.5.12</p>
    </div>
  );
};

export default Login;
